import { render, staticRenderFns } from "./ModalEditarProcessoRequisicao.vue?vue&type=template&id=35644a74&scoped=true"
import script from "./ModalEditarProcessoRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarProcessoRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarProcessoRequisicao.vue?vue&type=style&index=0&id=35644a74&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35644a74",
  null
  
)

export default component.exports